import { AutoComplete, Col, Form, Input, Row, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import "../../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";

import { authUserData } from "../../../utils/Helper";

const { Option } = Select;

const AddPincode = ({
  handleCancel,

  setReload,
  pincodeId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [areas, setAreas] = useState([]);
  const [suburbSearchList, setSuburbSearchList] = useState([]);

  const [searchValueBilling, setSearchValueBilling] = useState("");
  // const [weightList, setWeightList] = useState([]);
  const [countries, setCountries] = useState([]);
  // const [suburbList, setSuburbList] = useState([]);
  const [states, setStates] = useState([]);

  const initialState = {
    country: authUserData()?.country ? authUserData()?.country : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    customer_zone: null,
    suburb: null,
    zone: null,
    pincode: null,
  };

  const [state, setState] = useState(initialState);

  useEffect(() => {
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);
    authUserData()?.state
      ? getareaByState(authUserData()?.state)
      : getareaByState(1);
  }, []);
  useEffect(() => {
    const zoneGetById = async () => {
      if (pincodeId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`pincode/${pincodeId}/`);
          if (response.data.success) {
            const {
              id,
              country_name,
              state_name,
              customer_zone_name,
              zone_name,
              suburb_name,
              state_code,
              country_code,

              ...filteredResponse
            } = response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });
            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
              customer_zone: response.data.data.customer_zone_name,
              zone: response.data.data.zone_name,
              suburb: response.data.data.suburb_name,
            });

            getStateByCountry(response?.data?.data?.country);
            getzoneByState(response?.data?.data?.state);
            getareaByState(response?.data?.data?.state);
            getSuburbByzone(response?.data?.data?.zone);
            setapiLoading(false);
          }
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [pincodeId, modalKey]);
  const getCountryName = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest("country/?no_pagination=True");

      const { data } = response.data;

      setCountries(data);
      formRef.current.setFieldsValue(response.data.data);
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  const handleCountrySelectChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      customer_zone: null,
      zone: null,
      suburb: null,
    }));
    formRef.current.setFieldsValue({
      customer_zone: null,
      zone: null,
      suburb: null,
    });
    setAreas([]);
    setZones([]);
    setAreas([]);
    //setSuburbList([]);

    getareaByState(value);
    getzoneByState(value);
  };
  const getzoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };

  const getareaByState = async (id) => {
    const areaResponse = await getRequest(
      "customer-zone/?no_pagination=true&state_id=" + id
    );

    setAreas(areaResponse?.data?.data);
  };

  //   const handleSuburbChange = (value) => {
  //     setState((prevState) => ({
  //      ...prevState,
  //      suburb: value,
  //    }));

  //  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);
    authUserData()?.state
      ? getareaByState(authUserData()?.state)
      : getareaByState(1);
    handleCancel();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (pincodeId === null) {
        response = await postRequest("pincode/", state);
      } else {
        response = await patchRequest(`pincode/${pincodeId}/`, state);
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          pincodeId === null
            ? t("pincode_added_successfully")
            : t("pincode_updated_successfully")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleZoneChange = (value) => {
    // Find the zone name based on the selected zone id
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";

    // Update state and reset suburb/postcode lists
    setState((prevState) => ({
      ...prevState,
      zone: value,
      suburb: null,
    }));

    formRef.current.setFieldsValue({ suburb: null });
    //setSuburbList([]);
    setSuburbSearchList([]);
    //setWeightList([]);
    getWeightByZone(zoneName); // Pass the zoneName instead of the id
  };
  const handleAreaChange = (value) => {
    // Find the zone name based on the selected zone id
    // const selectedArea = areas.find((area) => area.id === value);
    // const areaName = selectedArea ? selectedArea.area : "";

    // Update state and reset suburb/postcode lists
    setState((prevState) => ({
      ...prevState,
      customer_zone: value ?? null,
    }));

    // formRef.current.setFieldsValue({ suburb: null});
    //setSuburbList([]);
    // setSuburbSearchList([]);
    //setWeightList([]);
    // getWeightByZone(areaName); // Pass the zoneName instead of the id
  };

  const onSearchBilling = async (value, id) => {
    setSearchValueBilling(value);
    value.length >= 3
      ? searchINBilling(!value ? null : value)
      : setSuburbSearchList([]);
  };
  const searchINBilling = async (value, id) => {
    const apiResponse = await getRequest(
      `suburb/?zone_id=${state.zone}&search_area=${value}`
    );
    if (apiResponse.data.results.success) {
      setSuburbSearchList(apiResponse.data.results.data);
    }
  };
  const handleSuburbSearchChange = (value) => {
    const selectedSuburb = suburbSearchList.find(
      (option) => option.id === value
    );
    if (selectedSuburb) {
      setState((prevState) => ({
        ...prevState,
        suburb: value, // Set the area name instead of ID
      }));

      formRef.current.setFieldsValue({ suburb: selectedSuburb.area });
    }
    if (selectedSuburb?.id) {
      getPostCodeBySuburb(selectedSuburb?.id);
    } else {
      console.log("Error In Suburb");
    }
  };

  const getSuburbByzone = async (id, value, suburb) => {
    try {
      setapiLoading(true);
      const suburbResponse = await getRequest(`suburb/?zone_id=${id}`);

      if (suburbResponse.data.results.success) {
        setSuburbSearchList(suburbResponse.data.results.data);
      }
      handleSuburbSearchChange();
    } catch {
      setapiLoading(false);
    }
  };

  const getPostCodeBySuburb = async (id) => {
    const pincodeResponse = await getRequest(
      "pincode/?no_pagination=true&suburb_id=" + id
    );
    const pincode = pincodeResponse?.data?.data.map((pincode) => ({
      id: pincode.id,
      name: pincode.pincode,
    }));
  };

  const getWeightByZone = async (zoneName) => {
    try {
      setapiLoading(true);

      const weightResponse = await getRequest(
        `delivery-rates/?state=${state.state}&zone=${zoneName}&no_pagination=true`
      );

      if (weightResponse.data.success) {
        //setWeightList(weightResponse?.data?.data);
      }

      setapiLoading(false);
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setapiLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="country"
                label={t("pl_country")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_country")}</Trans>, // change in translation
                  },
                ]}
              >
                <Select
                  placeholder={t("pl_select_country")}
                  name="country"
                  value={state.country_name}
                  showArrow
                  showSearch
                  onChange={handleCountrySelectChange}
                  optionFilterProp="children"
                >
                  {countries.map((country) => (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="state"
                label={t("pl_state")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_state")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="state"
                  label={t("pl_state")}
                  placeholder={t("pl_select_state")}
                  value={state.state}
                  onChange={handleStateSelectChange}
                  showArrow
                  showSearch
                  optionFilterProp="children"
                >
                  {states.map((state) => (
                    <Option key={state.id} value={state.id}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={12} lg={12} className="TextFeild">
              <Form.Item
                name="customer_zone"
                label={t("pl_area")}
                rules={[
                  {
                    required: false,
                    message: <Trans>{t("val_select_area")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("pl_select_area")}
                  showArrow
                  showSearch
                  allowClear
                  name="customer_zone"
                  value={state?.customer_zone}
                  optionFilterProp="children"
                  onChange={handleAreaChange}
                >
                  {areas.map((area) => (
                    <Option key={area.id} value={area.id}>
                      {area.customer_zone}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} className="TextFeild">
              <Form.Item
                name="zone"
                label={t("pl_zone")}
                // rules={[
                //   {
                //     required: true,
                //     message: <Trans>{t("val_select_zone")}</Trans>,
                //   },
                // ]}
              >
                <Select
                  placeholder={t("pl_select_zone")}
                  showArrow
                  showSearch
                  name="zone"
                  value={state?.zone}
                  optionFilterProp="children"
                  onChange={handleZoneChange}
                >
                  {zones.map((zone) => (
                    <Option key={zone.id} value={zone.id}>
                      {zone.zone}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} className="TextFeild">
              <Form.Item
                name="suburb"
                label={t("pl_suburb")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_subrub")}</Trans>,
                  },
                ]}
              >
                <AutoComplete
                  className="autoComplete"
                  onSearch={onSearchBilling}
                  value={state.suburb}
                  optionFilterProp="children"
                  allowClear
                  placeholder={t("pl_select_subrub")}
                  onChange={handleSuburbSearchChange}
                  disabled={!state.zone}
                >
                  {suburbSearchList.map((option) => (
                    <Option key={option.id} value={option.id}>
                      {option.area}
                    </Option>
                  ))}
                </AutoComplete>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="pincode"
                label={t("pl_pincode")}
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{4}$|^[0-9]{6}$/,
                    message: <Trans>{t("val_pincode")}</Trans>,
                  },
                  {
                    validator(_, value) {
                      if (value && value.length > 100) {
                        return Promise.reject(
                          new Error("Maximum length of 100 characters exceeded")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder={t("pl_enter_pincode")}
                  name="pincode"
                  value={state?.pincode}
                  onChange={handleInputChange}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault(); // Block any character except numbers
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label={t("save")}
              htmlType="Submit"
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddPincode.propTypes = {
  handleCancel: PropTypes.func.isRequired,

  setReload: PropTypes.func.isRequired,
  pincodeId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func,
};

export default AddPincode;
